import DownloadIcon from '@mui/icons-material/DownloadForOfflineOutlined';
import { Box, Button, type ButtonProps } from '@mui/material';
import { useEffect, useState } from 'react';
import { theme } from '@/theme';
import SVGSpinner from './SVGSpinner';

interface Props extends ButtonProps {
    isShowLabel?: boolean;
    isShowIcon?: boolean;
    iconPosition?: 'left' | 'right';
    label?: string;
    iconState?: 'default' | 'success' | 'loading';
}

export default function DownloadButton({
    isShowLabel = true,
    isShowIcon = true,
    iconPosition = 'left',
    label,
    iconState = 'default',
    ...rest
}: Props) {
    const [iconColor, setIconColor] = useState(theme.palette.neutral.N_700);

    useEffect(() => {
        switch (iconState) {
            case 'success':
                setIconColor(theme.palette.success.main);
                window.setTimeout(() => setIconColor(theme.palette.neutral.N_700), 3000);
                break;
            default:
                setIconColor(theme.palette.neutral.N_700);
        }
    }, [iconState]);

    return (
        <Button {...rest}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                {isShowLabel && iconPosition === 'right' && label}
                {isShowIcon && iconState === 'loading' && (
                    <SVGSpinner stroke={theme.palette.success.main} height={24} width={24} />
                )}
                {isShowIcon && iconState !== 'loading' && (
                    <DownloadIcon sx={{ color: iconColor }} />
                )}
                {isShowLabel && iconPosition === 'left' && label}
            </Box>
        </Button>
    );
}
